import React, { useEffect, useState } from "react";
import Select from "react-select";
import axios from "axios";

import storage from "components/Pixacom/storage";

import { newToast } from "../DSA/Toast";

const PixSelect = (props) => {
  const {
    id,
    inputId,
    name,
    placeholder,
    className = null,
    style = {},
    menuPlacement = "bottom",
    required = false,
    disabled = false,
    clearable = false,
    emptyValue,
    apiLink,
    data,
    editID = null,
    withoutIds = [],
    keyParameter = "id",
    small = undefined,
    value,
    isMulti = false,
    sortBy = null,
    sortDirection = "asc",
    onLoadComplete,
  } = props;

  const { onChange = () => {}, labelFormat } = props;

  const config = {
    headers: { Authorization: `Bearer ${storage.getItem("token")}` },
  };

  const [selectedValue, setSelectedValue] = useState(undefined);
  const [options, setOptions] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    if (data) {
      loadLocalData();
    } 
  }, [data]);

  useEffect(() => {
    if (data) {
      if (options.length === 0) loadLocalData();
      else if (data.length === 0 && options.length > 0) setOptions([]);
    }
    if (
      editID !== null &&
      (selectedValue === null || selectedValue === undefined)
    ) {
      setSelectedValue(editID);
    }
  }, [data]);

  useEffect(() => {
    if (apiLink) loadData();
  }, [apiLink]);

  useEffect(() => {
    setSelectedValue(editID);
  }, [editID]);

  // NOVÝ useEffect pro sledování value prop
  useEffect(() => {
    if (value !== undefined) {
      // Pokud je value objekt s property value, extrahuj ID
      if (typeof value === 'object' && value !== null && value.value) {
        setSelectedValue(value.value);
      } 
      // Pokud je value přímo ID
      else if (typeof value === 'number' || typeof value === 'string') {
        setSelectedValue(value);
      }
      // Pokud je value null nebo undefined
      else {
        setSelectedValue(null);
      }
    }
  }, [value]);

  useEffect(() => {
    if (emptyValue) {
      let isExist = options.find((itm) => itm.value === null);

      if (!isExist)
        setOptions((prevState) => [
          { value: null, label: emptyValue, object: null },
          ...prevState,
        ]);
    }
  }, [emptyValue]);

  const loadLocalData = () => {
    if (labelFormat) {
      let rowData = [];

      data.forEach((item) => {
        let label = labelFormat(item);

        rowData.push({
          value: item[keyParameter],
          label: label,
          object: item
        });
      });

      setOptions(sortOptions(rowData));
    } else {
      setOptions(sortOptions(data));
    }

    setIsLoading(false);
    if (onLoadComplete) {
      onLoadComplete();
    }
  };

  const loadData = async () => {
    setIsLoading(true);

    try {
      let response = await axios.get(apiLink, config);

      if (response.status >= 200 && response.status <= 299) {
        let data = response.data;

        if (data) {
          let rowData = [];

          if (emptyValue) {
            rowData.push({ value: null, label: emptyValue, object: null });
          }

          data.forEach((item) => {
            let label = "";

            if (labelFormat) label = labelFormat(item);
            else label = item.name;

            rowData.push({
              value: item[keyParameter],
              label: label,
              object: item,
            });
          });

          setOptions(sortOptions(rowData));
          setIsLoading(false);

          if (onLoadComplete) {
            onLoadComplete();
          }
        }
      } else
        console.error(
          "Bad response status: " + response.status + " from " + apiLink
        );
    } catch (err) {
      newToast.error("Data loading error", err.message);
    }
  };

  const handleChange = (event) => {
    if (isMulti) {
      const hasEmptyValue = Array.isArray(event)
        ? event.some((item) => item.value === null)
        : false;

      if (hasEmptyValue) {
        onChange([], []);
        setSelectedValue([]);
        return;
      }

      const values = Array.isArray(event)
        ? event.map((item) => item.value)
        : [];

      onChange(values, event);
      setSelectedValue(values);
      return;
    }

    onChange(event?.value, event?.object);
    setSelectedValue(event?.value);
  };

  const customStyles = () => {
    if (small)
      return {
        control: (provided, state) => ({
          ...provided,
          minHeight: "25px",
          height: "25px",
          boxShadow: state.isFocused ? null : null,
        }),

        valueContainer: (provided, state) => ({
          ...provided,
          height: "25px",
          padding: "0 6px",
        }),

        input: (provided, state) => ({
          ...provided,
          margin: "0px",
        }),
        indicatorSeparator: () => ({
          display: "none",
        }),
        indicatorsContainer: (provided, state) => ({
          ...provided,
          height: "25px",
        }),
      };
  };

  const sortOptions = (items) => {
    if (!sortBy) return items;

    const sortedItems = [...items].sort((a, b) => {
      let aValue;
      let bValue;

      // pokud řadíš podle labelu/value přímo v options
      if (sortBy === "label" || sortBy === "value") {
        aValue = a?.[sortBy];
        bValue = b?.[sortBy];
      } 
      // jinak řaď podle atributu uvnitř object
      else {
        aValue = a?.object?.[sortBy];
        bValue = b?.object?.[sortBy];
      }

      // fallback
      if (aValue === undefined || aValue === null) aValue = "";
      if (bValue === undefined || bValue === null) bValue = "";

      // stringy
      if (typeof aValue === "string" || typeof bValue === "string") {
        const result = String(aValue).localeCompare(String(bValue), "cs", {
          sensitivity: "base",
          numeric: true,
        });

        return sortDirection === "desc" ? -result : result;
      }

      // čísla
      if (aValue < bValue) return sortDirection === "desc" ? 1 : -1;
      if (aValue > bValue) return sortDirection === "desc" ? -1 : 1;
      return 0;
    });

    return sortedItems;
  };

  const placeholderText =
    selectedValue === null || selectedValue === undefined
      ? emptyValue || placeholder || "Select..."
      : placeholder || "Select...";

  // OPRAVENO: Lepší logika pro určení aktuální hodnoty
  const getCurrentValue = () => {
    if (isMulti) {
      if (!Array.isArray(selectedValue)) return [];

      return options.filter((item) =>
        selectedValue.map(Number).includes(Number(item.value))
      );
    }

    if (selectedValue === null) {
      return options.find((item) => item.value === null);
    }

    if (selectedValue !== null && selectedValue !== undefined) {
      return options.find((item) => item.value == selectedValue);
    }

    return null;
  };

  return (
    <Select
      id={id}
      inputId={inputId}
      name={name}
      menuPlacement={menuPlacement}
      isDisabled={disabled}
      isLoading={isLoading}
      className={className}
      isClearable={clearable}
      menuPortalTarget={document.body}
      menuPosition={props.menuPosition || "fixed"}
      styles={{
        ...style,
        ...customStyles(),
        menuPortal: (base) => ({ ...base, zIndex: 20000 }),
        menu: (provided) => ({ ...provided, zIndex: 9999 }),
      }}
      placeholder={placeholderText}
      onChange={handleChange}
      options={options.filter((item) => !withoutIds.includes(item.value))}
      value={getCurrentValue()}
      required={required}
      isMulti={isMulti}
    />
  );
};

export default PixSelect;
